import { useLocation } from 'react-router-dom';

import type { ParsedQuery } from 'query-string';
import { parse } from 'query-string';

export const useQueryParams: ParsedQuery = () => {
  const location = useLocation();

  return parse(location.search);
};
